// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__6qu3O","title":"Images45_title__xIGbQ","images":"Images45_images__3WjrM"};